import * as React from "react";

import "./type-homevalue.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Static}         from "@Common/react/static";

import {InformationBadge} from "../../../../../common/design2/information-badge/information-badge";

export const TypeHomevalue = ({disabled, itemId, next}) => cs(
    consumeContext("company"),
    consumeContext("systemConstants"),
    ["url", ({company, systemConstants}, next) => next(
        !itemId ? null : (
            systemConstants.value?.MN_HOMEVALUE_URL +
            encodeURIComponent(btoa(JSON.stringify({
                idCompany: company?.idCompany,
                idOrder: itemId,
                preview: true,
            })))
        )
    )],

    ["disabled1", (_, next) => Static({getInitValue: () => disabled, next})],
    ({disabled1, url}) => next({
        staticControl: true,
        hidden: disabled1,

        activeUrl: url,
        renderControl: ({}) => cs(
            () => (
                <div className="type-homevalue-12q">
                    <div {...{
                        className: "label",
                        "xd-qa-type": "label",
                        "xd-qa-name": "Redirect URL - Home Value",
                    }}>
                        Home Value
                    </div>

                    {InformationBadge({
                        getTooltip: () => "Shows recipients their home value and comparable homes. Provides a quick and easy way to contact the agent.",
                        height: 14,
                        xdQaName: "Redirect URL - Home Value Information",
                    })}

                    <a {...{
                        onClick: (e) => {
                            e.stopPropagation();
                            url && window.open(url);
                        },
                    }}>
                        Example
                    </a>
                </div>
            )
        ),
    }),
);

